export function getGitCommitId () {
  return process.env.VUE_APP_CURRENT_GIT_COMMIT_ID
}
